// extracted by mini-css-extract-plugin
export default {"asideLogo":"Aside_asideLogo__84fNS"};